module.exports = __webpack_public_path__ + "static/media/prinz-eugen.31b574d1.png";